import React from 'react';
import { Button, Modal } from 'antd';
import IntlMessages from 'util/IntlMessages';

export const ALERT_TYPES_FIELDS = {
  LIMIT_USERS: 'LIMIT_USERS',
  MARGIN_RANGE_DATE: 'MARGIN_RANGE_DATE',
};
export default function AlertFiltersModal({ alertType, onContinue, onClose }) {
  const ALERT_TYPES = {
    [ALERT_TYPES_FIELDS.LIMIT_USERS]: {
      title: 'work.direction.filter.limit.title.alert',
      message: 'work.direction.filter.limit.message.alert',
    },
    [ALERT_TYPES_FIELDS.MARGIN_RANGE_DATE]: {
      title: 'work.direction.filter.range.title.alert',
      message: 'work.direction.filter.range.message.alert',
    },
  };

  if (!alertType) return null;
  return (
    <Modal open closable={false} footer={null} width={322}>
      <div className="gx-flex-column gx-align-items-center">
        <div className="gx-flex-row gx-justify-content-center gx-mb-2 gx-text-warning">
          <span className="material-symbols-outlined">info</span>
        </div>
        <div>
          <p className="gx-fs-md gx-font-weight-bold">
            <IntlMessages id={ALERT_TYPES[alertType].title} />
          </p>
        </div>
        <div>
          <p className="gx-fs-md">
            <IntlMessages id={ALERT_TYPES[alertType].message} />
          </p>
        </div>
      </div>
      <div className="gx-flex-row gx-justify-content-center gx-mt-2 gx-guarnic-gap-2">
        <Button onClick={onClose} className="gx-m-0 gx-flex-1">
          <IntlMessages id="button.cancel" />
        </Button>
        <Button onClick={onContinue} type="primary" className="gx-m-0 gx-flex-1">
          <IntlMessages id="button.continue" />
        </Button>
      </div>
    </Modal>
  );
}
